<div class="bloc-title mb-3">my live campaigns</div>
<ul class="card-deck p-0">
    <li class="card">
        <div class="card-body p-3 mb-3">
            <div class="d-flex justify-content-between align-items-center mb-3">
                <h4 class="text-gray-500 montserrat-bold">Infiniti QX60</h4>
                <span class="text-small text-gray">End date:<br />02-06-2020</span>
            </div>
            <img src="./assets/images/infiniti.jpg" class="card-img-top br-8" alt="..." />
        </div>
        <div class="card-footer p-0">
            <div
                class="campaign-stat d-flex align-items-center justify-content-between border-bottom px-4 pb-3 mb-3"
            >
                <img src="./assets/images/icons/dashboard/plays.svg" alt="Plays" title="Plays" />
                <span class="text-blue campaign-stat-number">600</span>
            </div>
            <div
                class="campaign-stat d-flex align-items-center justify-content-between border-bottom px-4 pb-3 mb-3"
            >
                <img
                    src="./assets/images/icons/dashboard/heart.svg"
                    alt="Impressions"
                    title="Impressions"
                />
                <span class="text-danger campaign-stat-number">1,380</span>
            </div>
            <div class="campaign-stat d-flex align-items-center justify-content-between px-4 pb-3">
                <img src="./assets/images/icons/dashboard/dollar.svg" alt="Budget" title="Budget" />
                <span class="text-purple campaign-stat-number">2,500.00</span>
            </div>
        </div>
    </li>
    <li class="card">
        <div class="card-body p-3 mb-3">
            <div class="d-flex justify-content-between align-items-center mb-3">
                <h4 class="text-gray-500 montserrat-bold">Etisalat 5G</h4>
                <span class="text-small text-gray">End date:<br />06-10-2020</span>
            </div>
            <img src="./assets/images/etisalat-5g.jpg" class="card-img-top br-8" alt="..." />
        </div>
        <div class="card-footer p-0">
            <div
                class="campaign-stat d-flex align-items-center justify-content-between border-bottom px-4 pb-3 mb-3"
            >
                <img src="./assets/images/icons/dashboard/plays.svg" alt="Plays" title="Plays" />
                <span class="text-blue campaign-stat-number">11,278</span>
            </div>
            <div
                class="campaign-stat d-flex align-items-center justify-content-between border-bottom px-4 pb-3 mb-3"
            >
                <img
                    src="./assets/images/icons/dashboard/heart.svg"
                    alt="Impressions"
                    title="Impressions"
                />
                <span class="text-danger campaign-stat-number">6,020</span>
            </div>
            <div class="campaign-stat d-flex align-items-center justify-content-between px-4 pb-3">
                <img src="./assets/images/icons/dashboard/dollar.svg" alt="Budget" title="Budget" />
                <span class="text-purple campaign-stat-number">15,450.00</span>
            </div>
        </div>
    </li>
</ul>
<div class="bullets d-flex align-items-center justify-content-center">
    <span class="selected"></span>
    <span></span>
    <span></span>
</div>
